// extracted by mini-css-extract-plugin
export var arrow = "_2m-6";
export var changeItem = "_2m-3";
export var changesHeader = "_2m-1";
export var changesList = "_2m-2";
export var container = "_2m-0";
export var pathLabel = "_2m-4";
export var value = "_2m-7";
export var valuesContainer = "_2m-5";